module.exports = __webpack_public_path__ + "static/media/sl-podjetniski-sklad-s.8d8a543f.jpg";